module.exports = __webpack_public_path__ + "media/auto_data/check-on@2x-cef6fdf8.png";